<template>
    <div>
        <table class="table has-sticky-header is-hoverable items-table">
            <thead>
                <tr>
                    <slot name="th-bulk-action"/>
                    <slot name="th-start"></slot>
                    <slot v-if="!bulkActionOpen" name="table-headers">
                        <sort-column
                            v-for="field in fields"
                            :key="field.handle"
                            :class="fieldCustomClass(field)"
                            :name="field.name"
                            :handle="field.handle"
                            :active-sort="sortColumnHandle"
                            :sort-descending="sortDescending"
                            :disabled="field.sortingDisabled"
                            :active-projection-columns="activeFieldHandles"
                            :available-grouped-fields="availableGroupedFields"
                            :tooltip="field.tooltip"
                            v-on:change:column="$emit('change-sort-column', $event)"
                            v-on:change:direction="$emit('change-sort-direction', $event)"
                            v-on:add:column="$emit('add-projection-column', $event)"
                            v-on:remove="$emit('remove-projection-column', $event)"
                            v-on:move="$emit('move-projection-column', $event)"
                        ></sort-column>
                    </slot>
                    <slot name="th-end"></slot>
                </tr>
            </thead>
            <tbody
                ref="tableBody"
                v-if="!fetching"
            >
                <component
                    v-for="(item, i) in items"
                    :key="i"
                    :is="customTableRowRenderComponent"
                    :item="item"
                    v-bind="customTableRowRenderComponentProps"
                    @click="$emit('row-click', item)"
                    :class="getClass(item)"
                    :title="getTooltip(item)"
                >
                    <slot name="tr-bulk-action" v-bind:item="item"/>
                    <slot name="tr-start" v-bind:item="item"/>
                    <td
                        v-for="field in fields"
                        :key="field.handle"
                        :class="fieldCustomClass(field)"
                    >
                        <component
                            :is="field.displayComponent"
                            :value="item[field.contextKey]"
                            :is-full="true"
                            or="N/A"
                            :field="field"
                            :item="item"
                            v-bind="field.componentProps"
                            @broadcast="$emit('broadcast', {...$event, item : item, field : field })"
                        ></component>
                    </td>
                    <slot name="tr-end" v-bind:item="item"/>
                </component>
            </tbody>
        </table>

        <loading
            class="m-t-xl"
            v-if="fetching"
        ></loading>
        <div
            v-else-if="!items.length"
            class="no-items"
        >
            <slot name="no-items">
                Nothing matches your filters
            </slot>
        </div>

    </div>
</template>

<script>
import Timestamp from '../../../elements/Timestamp';
import Money from '../../../elements/Money';
import Number from '../../../elements/Number';

import SortColumn from './SortColumn';
import _ from 'underscore';
import Percentage from "../../../elements/Percentage";
import ImagesDisplay from "$flx/components/abstract-search/projections/column-type-display/ImagesDisplay";
import TimeSince from "$flx/elements/TimeSince";

export default {
    name : "ItemsTable",
    components : {
        SortColumn,
    },
    props : {
        fields : {
            type : Array,
            required : true,
        },
        items : {
            type : Array,
            required : true,
        },
        fetching : {
            type : Boolean,
            required : true,
        },
        availableGroupedFields : {
            type : Array,
            required : true,
        },
        sortColumnHandle : {
            type : String,
            required : true,
        },
        sortDescending : {
            type : Boolean,
            required : true,
        },
        bulkActionOpen : {
            type : Boolean,
            required : true,
        },
        customTableRowRenderComponent : {
            type : [String, Object],
            required : true,
        },
        customTableRowRenderComponentProps : {
            type : Object,
        },
        disabled : {
            type : Object,
            required : false,
        },
    },
    computed : {
        activeFieldHandles () {
            return _.pluck(this.fields, 'handle');
        }
    },
    methods : {
        fieldCustomClass (field) {
            const classes = {
                'has-text-right' : field.displayComponent && [Number.name, Money.name, Percentage.name].indexOf(field.displayComponent.name) !== -1,
                'is-skinny-no-wrap' : [Timestamp.name, Money.name, Number.name, Percentage.name, ImagesDisplay.name, TimeSince.name].indexOf(field.displayComponent.name) !== -1,
            };
            if(field.columnClass) {
                classes[field.columnClass] = true;
            }
            return classes;
        },
        isDisabled(item) {
            return this.disabled
                && this.disabled.itemIds
                && this.disabled.idFieldName
                && this.disabled.itemIds.includes(item[this.disabled.idFieldName]);
        },
        getClass(item) {
            return this.isDisabled(item)
                ? ['is-disabled', this.disabled.rowClasses]
                : '';
        },
        getTooltip(item) {
            return this.isDisabled(item)
                ? this.disabled.rowTooltip
                : '';
        },
    },
}
</script>

<style scoped>

</style>
